<template>
  <categories-selection-popup title="בחירת קטגוריה ליעד" :categoriesOptions="currentTrackingCategories"
                              :onBack="back" @done-clicked="onSave" button-text="הבא">
    <template v-slot:sub-title>
      <span>באיזו קטגוריה נתמקד החודש וננסה</span>
      <span class="bold-sub-title">
        לצמצם בה את ההוצאות?
      </span>
    </template>
  </categories-selection-popup>
</template>

<script>
import * as _ from 'lodash';
import Segment from '@/Segment';
import { mapActions, mapGetters } from 'vuex';
import CategoriesSelectionPopup from '../CategoriesSelectionPopup';

export default {
  name: 'SetCategoryChallenge',
  components: {
    CategoriesSelectionPopup,
  },
  computed: {
    ...mapGetters('createTrackingCategory', ['currentTrackingCategories']),
  },
  created() {
    this.selectTrackingCategory(_.first(this.currentTrackingCategories));
  },
  methods: {
    ...mapActions('createTrackingCategory', ['selectTrackingCategory', 'selectTrackingCategory']),
    back() {
      this.$emit('back-clicked');
    },
    onSave() {
      Segment.trackUserInteraction('SetCategoryChallenge_SaveClicked', {
        selectedCategory: this.selectedCategory,
      });
      this.$emit('done-clicked');
    },
  },
};
</script>

<style scoped>
  .bold-sub-title {
    font-weight: bold;
  }
</style>
